import { Injectable } from '@angular/core';
import { SessionService } from '@app/security/session.service';

@Injectable()
export class SmartActionsSharedService {
  constructor(private sessionService: SessionService) {}

  showSmartActions(): boolean {
    const client = this.sessionService.getCurrentUsersClient();
    return client?.smart_actions_enabled ?? false;
  }
}
